import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveSeo } from "./seo.config";
import { useSeo } from "./useSeo";
import { SeoMeta } from "./seo.types";

/**
 * Drives document.head from the current route.
 *
 * Mounted once inside <BrowserRouter>. Deliberately renders nothing, so no
 * page component needs to know SEO exists - the route table in seo.config.ts
 * is the single source of truth. Add a route there and it is covered.
 */
export const RouteSeo = () => {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  // Matches the auth check used by Routes.tsx so "/" reports the right title.
  const isAuthenticated = !!localStorage.getItem("token");

  const meta: SeoMeta = useMemo(() => {
    const resolved = resolveSeo(pathname, isAuthenticated);

    return {
      ...resolved,
      title: resolved.titleKey
        ? t(resolved.titleKey, { defaultValue: resolved.title })
        : resolved.title,
      description: resolved.descriptionKey
        ? t(resolved.descriptionKey, { defaultValue: resolved.description })
        : resolved.description,
    };
  }, [pathname, isAuthenticated, t, i18n.language]);

  useSeo(meta, pathname, i18n.language);

  return null;
};

export default RouteSeo;
